import request from '@/utils/request';
/**
 * 发放商品
 * @param params 参数
 */
export const updateResend = (data: any) =>
  request({
    url: '/api/v1/omc/pay/resend?order_no=' + data.order_no,
    method: 'put',
  });
/**
 * 查询充值记录
 * @param params 参数
 */
export const getPayments = (params: any) =>
  request({
    url: '/api/v1/omc/pay',
    method: 'get',
    params,
  });

/**
 * 查询消费订单
 * @param params 参数
 */
export const getExpense = (params: any) =>
  request({
    url: '/api/v1/omc/expense',
    method: 'get',
    params,
  });
/**
 * 列举月/周卡
 */
export const getSubcard = (params: any): Promise<any> =>
  request({
    url: '/api/v1/omc/subcard',
    method: 'get',
    params,
  });
/**
 * 列举云币卡
 */
export const getCoincard = (params: any): Promise<any> =>
  request({
    url: '/api/v1/omc/coincard',
    method: 'get',
    params,
  });
/**
 * 获取云币充值
 */
export const getCloudRecharge = (params: any): Promise<any> =>
  request({
    url: '/api/v1/omc/live/yun/list',
    method: 'get',
    params,
  });
/**
 * 编辑月/周卡
 */
export const editSubcard = (data: any): Promise<any> =>
  request({
    url: '/api/v1/omc/subcard',
    method: 'post',
    data,
  });
/**
 * 新增云朵充值
 */
export const addCloudRecharge = (data: any): Promise<any> =>
  request({
    url: '/api/v1/omc/live/yun/add',
    method: 'post',
    data,
  });
/**
 * 修改云朵充值
 */
export const exitCloudRecharge = (data: any): Promise<any> =>
  request({
    url: '/api/v1/omc/live/yun/edit',
    method: 'put',
    data,
  });
/**
 * 删除云朵充值
 */
export const deleteCloudRechage = (id: Number): Promise<any> =>
  request({
    url: `/api/v1/omc/live/yun/remove/${id}`,
    method: 'delete',
  });

/**
 * 删除周期卡
 */
export const deleteSubcard = (id: Number): Promise<any> =>
  request({
    url: `/api/v1/omc/subcard/${id}`,
    method: 'delete',
  });

/**
 * 周期卡排序
 */
export const sortSubcard = (data: any): Promise<any> =>
  request({
    url: `/api/v1/omc/subcard/sort`,
    method: 'put',
    data,
  });

/**
 * 周期卡发布
 */
export const releaseSubcard = (data: any): Promise<any> =>
  request({
    url: `/api/v1/omc/subcard/release`,
    method: 'put',
    data,
  });

/**
 * 编辑云币卡
 */
export const editCoincard = (data: any): Promise<any> =>
  request({
    url: '/api/v1/omc/coincard',
    method: 'post',
    data,
  });

//获取标签卡
export const getLableSetting = (idx: String): Promise<any> =>
  request({
    url: `/api/v1/omc/tag/${idx}`,
    method: 'get',
  });

//添加标签
export const addLableSetting = (data: any): Promise<any> =>
  request({
    url: '/api/v1/omc/tag/save',
    method: 'post',
    data,
  });
//删除标签
export const deleteLableSetting = (data: any): Promise<any> =>
  request({
    url: '/api/v1/omc/tag/remove',
    method: 'delete',
    data,
  });
/**
 * 清理充值记录
 * @param params 参数
 */
export const updateUserRecharge = (data: any) =>
  request({
    url: '/api/v1/omc/pay/goods/clean',
    method: 'put',
    data,
  });
/**
 * 【商品配置】配置apple product id
 * @param params 参数
 */
export const setIOSId = (data: any) =>
  request({
    url: '/api/v1/omc/product/apple_product_id',
    method: 'put',
    data,
  });
